import { useContext, useEffect, useState } from "react";
import { ArrayFieldTemplateProps } from "@rjsf/utils";
import {
  Backspace,
  CaretDown,
  CaretUp,
  ChartLine,
  Divide,
  PlusCircle,
} from "@phosphor-icons/react";
import { Dog, Plus } from "@phosphor-icons/react/dist/ssr";
import { text } from "stream/consumers";

function MappingArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const { className, items, canAdd, onAddClick } = props;

  const customAddClick = () => {
    onAddClick();
  };

  return (
    <div className={className}>
      {/* Cabecera con el título y el botón */}
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        {/* Título a la izquierda */}
        <div></div>

        {/* Botón para añadir mascotas a la derecha */}
        {canAdd && (
          <button
            className="btn btn-outline-primary"
            onClick={customAddClick}
            type="button"
          >
            <PlusCircle size={25}></PlusCircle>
            Añadir mapeo
          </button>
        )}
      </div>

      {/* Contenedor principal */}
      <div>
        {/* Listado de mascotas */}
        <div
          className="card-body"
          style={{
            paddingTop: "0",
            maxHeight: "500px", // Aproximadamente 5 elementos de altura
            height: "500px", // Aproximadamente 5 elementos de altura
            overflowY: "auto",
          }}
        >
          {items &&
            items.map((element) => (
              <div key={element.key} className={`card mb-3`}>
                <div className="card-body">
                  {element.children}
                  <div style={{ textAlign: "right" }}>
                  <span
                    onClick={element.onDropIndexClick(element.index)}
                    style={{
                      cursor: "pointer",
                      marginRight: "10px",
                      color: "#e50000",
                      marginTop: "10px",
                      marginLeft: "10px",
                      textAlign: "right",
                    }}
                  >
                    Borrar
                  </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default MappingArrayFieldTemplate;
